export default __webpack_public_path__ + "static/media/Group.cdbc442b.svg";